export default __webpack_public_path__ + "static/media/cancel.1e057fde.svg";